var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RdText',[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.row[_vm.column.field])))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }